const DeliveryTab = () => {
  return (
    <div className="">
      <p>
        <span className="text-base block text-black">Numquam, sapiente illo. Sit</span>
        <span className="text-sm text-[#828282]">
          error voluptas repellat rerum quidem, soluta enim perferendis
          voluptate Distinctio, officia quis dolore quos sapiente tempore alias.
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Numquam,
          sapiente illo. Sit error voluptas repellat rerum quidem, soluta enim
          perferendis voluptates laboriosam. Distinctio, officia quis dolore
          quos sapiente tempore alias.
        </span>
      </p>
    </div>
  );
};

export default DeliveryTab;
